import { defineComponent as _defineComponent } from 'vue'
import type { CreditFragment } from '@/pages/graphql/fragments/TitleDetails.fragment';

import { SnowplowPersonContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { CollectionType } from '@/enums/collection-type';

import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { useUserStore } from '@/stores/pinia/useUserStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleCreditName',
  props: {
    credit: null
  },
  setup(__props: any) {

const props = __props as {
	credit: CreditFragment;
};



const userStore = useUserStore();
const { updateRouterState } = useFilterStore();

function clicked({ searchString, personId }: { searchString?: string; personId?: number }) {
	if (!props.credit?.profilePath) {
		userStore.saveSearchTerm(searchString);
		updateRouterState({
			collectionType: CollectionType.SEARCH,
			routeQuery: { q: searchString, person_id: personId },
		});
	}

	TrackingHelper.trackEvent(
		'persons_credit_name',
		{
			action: 'clicked',
			label: props.credit?.role,
			property: `${personId}`,
		},
		// credit prop sets a non-null default value but TS isn't catching it (Vue 2)
		[new SnowplowPersonContext(personId!, searchString!)]
	);
}

return { __sfc: true,props, userStore, updateRouterState, clicked }
}

})